var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5402 16.7188C21.3973 16.7188 17.2991 20.8973 17.2991 25.9598C17.2991 31.1027 21.3973 35.2009 26.5402 35.2009C31.6027 35.2009 35.7813 31.1027 35.7813 25.9598C35.7813 20.8973 31.6027 16.7188 26.5402 16.7188ZM26.5402 31.9866C23.2455 31.9866 20.5134 29.3348 20.5134 25.9598C20.5134 22.6652 23.1652 20.0134 26.5402 20.0134C29.8348 20.0134 32.4866 22.6652 32.4866 25.9598C32.4866 29.3348 29.8348 31.9866 26.5402 31.9866ZM38.2723 16.3973C38.2723 15.192 37.308 14.2277 36.1027 14.2277C34.8973 14.2277 33.933 15.192 33.933 16.3973C33.933 17.6027 34.8973 18.567 36.1027 18.567C37.308 18.567 38.2723 17.6027 38.2723 16.3973ZM44.3795 18.567C44.2188 15.6741 43.5759 13.1027 41.4866 11.0134C39.3973 8.92411 36.8259 8.28125 33.933 8.12054C30.9598 7.95982 22.0402 7.95982 19.067 8.12054C16.1741 8.28125 13.683 8.92411 11.5134 11.0134C9.42411 13.1027 8.78125 15.6741 8.62054 18.567C8.45982 21.5402 8.45982 30.4598 8.62054 33.433C8.78125 36.3259 9.42411 38.817 11.5134 40.9866C13.683 43.0759 16.1741 43.7188 19.067 43.8795C22.0402 44.0402 30.9598 44.0402 33.933 43.8795C36.8259 43.7188 39.3973 43.0759 41.4866 40.9866C43.5759 38.817 44.2188 36.3259 44.3795 33.433C44.5402 30.4598 44.5402 21.5402 44.3795 18.567ZM40.5223 36.567C39.9598 38.1741 38.6741 39.3795 37.1473 40.0223C34.7366 40.9866 29.1116 40.7455 26.5402 40.7455C23.8884 40.7455 18.2634 40.9866 15.933 40.0223C14.3259 39.3795 13.1205 38.1741 12.4777 36.567C11.5134 34.2366 11.7545 28.6116 11.7545 25.9598C11.7545 23.3884 11.5134 17.7634 12.4777 15.3527C13.1205 13.8259 14.3259 12.6205 15.933 11.9777C18.2634 11.0134 23.8884 11.2545 26.5402 11.2545C29.1116 11.2545 34.7366 11.0134 37.1473 11.9777C38.6741 12.5402 39.8795 13.8259 40.5223 15.3527C41.4866 17.7634 41.2455 23.3884 41.2455 25.9598C41.2455 28.6116 41.4866 34.2366 40.5223 36.567Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -0.955176,
    y: -0.291035,
    width: 54.9104,
    height: 54.9104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.16414
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.727588
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.101961 0 0 0 0 0.466667 0 0 0 0.0337375 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 21.325,
    y1: 76.85,
    x2: 97.15,
    y2: -0.550001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147864,
    stopColor: "#F6640E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443974,
    stopColor: "#BA03A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733337,
    stopColor: "#6A01B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B01B9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta-icon.610561d89bc47e28cba3e8be742e7d24.svg";
export { ForwardRef as ReactComponent };